import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

export const DeleteImagePopup = (props) => {
  return (
    <Modal show={props.show} onHide={props.onHide} animation={false}>
      <Modal.Header closeButton>
        <Modal.Title>Lösche Bild</Modal.Title>
      </Modal.Header>
      <Modal.Body>Möchten Sie dieses Bild wirklich löschen? </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>
          Schließen
        </Button>
        <Button variant="primary" onClick={props.onDelete}>
          Löschen{" "}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
